import { Box } from '@mui/material';
import { fMonthDayYear, fDateTime } from '../../utils/formatTime';
import Iconify from '../iconify';

const renderIcon = (value, icon) => <Box>
  <Iconify icon={icon} width={13} height={13} /> {value}
</Box>;

const dateAdded = {
  field: 'dateAdded',
  headerName: 'Date Added',
  type: 'customDate',
  width: 130,
  renderCell: (params) => renderIcon(fMonthDayYear(params.value), 'material-symbols:calendar-today-outline'),
  valueGetter: (params) => new Date(params.value),
};

const startDate = {
  field: 'startDate',
  headerName: 'Start Date',
  type: 'customDate',
  width: 175,
  renderCell: (params) => params.value === "" ? "" : renderIcon(params.value ? fDateTime(params.value) : " - ", 'material-symbols:calendar-today-outline'),
  valueGetter: (params) => params.value == null ? "" : new Date(params.value),
};

const endDate = {
  field: 'endDate',
  headerName: 'End Date',
  type: 'customDate',
  width: 175,
  renderCell: (params) => params.value === "" ? "" : renderIcon(params.value ? fDateTime(params.value) : " - ", 'material-symbols:calendar-today-outline'),
  valueGetter: (params) => params.value == null ? "" : new Date(params.value),
};

const title = {
  field: 'title',
  headerName: 'Title',
  flex: 1.5,
  renderCell: (params) => <Box sx={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>{params.value}</Box>,
  type: 'customSelect',
};


const NOTICES = [title, dateAdded, startDate, endDate];

export { NOTICES };
